import { render } from "./ConsumerSuccess.vue?vue&type=template&id=36ffb633"
import script from "./ConsumerSuccess.vue?vue&type=script&lang=js"
export * from "./ConsumerSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script